// Import the functions you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAD0dX9Tg0vTcXoU1nfql8tnOrnnOdN1cU",
  authDomain: "travelkariye.firebaseapp.com",
  projectId: "travelkariye",
  storageBucket: "travelkariye.firebasestorage.app",
  messagingSenderId: "313568375133",
  appId: "1:313568375133:web:fa28c1e429d1954250b8b4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Export Firestore
export { db };